import { createContext, useContext } from 'react'
import { Can as CaslCan } from '@casl/react'

export const AbilityContext = createContext()

export const Can = props => {
  const ability = useContext(AbilityContext)

  return <CaslCan {...props} ability={ability} />
}
